import { useState } from 'react';
import { Checkbox } from 'antd';
import { Button } from '@cropler/ui-kit';
import styles from './stylesChartsCustom.module.scss';

import { CustomCharts } from '../../constants/keys';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const ChartsCustomFilter = ({ metricsMap, showSoilData, chartsMap, saveChart, showBbchData, t, countOfDepths }) => {
  const [selected, setSelected] = useState([]);
  const [showMessage, setShowMessage] = useState(false);

  const onChange = (values) => {
    if (values.length <= 2) setSelected(values);
    setShowMessage(false);
  };

  const isDisabled = (id) => selected.length >= 2 && !selected.includes(id);

  const onSave = () => {
    if (selected.length !== 2) return;
    const existing = JSON.parse(localStorage.getItem(CustomCharts) || '[]');
    const isDuplicate = existing.some(
      (pair) => pair.length === 2 && pair.includes(selected[0]) && pair.includes(selected[1]),
    );
    if (isDuplicate) {
      setShowMessage(true);
      return;
    }
    localStorage.setItem(CustomCharts, JSON.stringify([...existing, selected]));
    setSelected([]);
    saveChart();
  };

  return (
    <div className={styles.chartsCustomFilter}>
      <Checkbox.Group
        value={selected}
        style={{ width: '100%' }}
        onChange={onChange}
        className={styles.chartsCustomFilterList}
      >
        {/*Weather*/}
        <div className={styles.chartsCustomFilterItem}>
          <div className={styles.chartsCustomFilterItemTitle}>
            <CroplerIcon name="weather" />
            {t('charts.types.weather')}
          </div>
          <Checkbox value={chartsMap.temperature.id} disabled={isDisabled(chartsMap.temperature.id)}>
            {chartsMap.temperature.title}
          </Checkbox>
          {metricsMap.includes(chartsMap.gdd.id) && (
            <Checkbox value={chartsMap.gdd.id} disabled={isDisabled(chartsMap.gdd.id)}>
              {chartsMap.gdd.title}
            </Checkbox>
          )}
          <Checkbox value={chartsMap.humidity.id} disabled={isDisabled(chartsMap.humidity.id)}>
            {chartsMap.humidity.title}
          </Checkbox>
          <Checkbox value={chartsMap.dew.id} disabled={isDisabled(chartsMap.dew.id)}>
            {chartsMap.dew.title}
          </Checkbox>
          {/*{metricsMap.includes(chartsMap.rain.id) && (*/}
          {/*  <Checkbox value={chartsMap.rain.id} disabled={isDisabled(chartsMap.rain.id)}>*/}
          {/*    {chartsMap.rain.title}*/}
          {/*  </Checkbox>*/}
          {/*)}*/}
        </div>

        {/*Crop*/}
        <div className={styles.chartsCustomFilterItem}>
          <div className={styles.chartsCustomFilterItemTitle}>
            <CroplerIcon name="plant" />
            {t('charts.types.crop')}
          </div>
          {metricsMap.includes(chartsMap.leafArea.id) && (
            <Checkbox value={chartsMap.leafArea.id} disabled={isDisabled(chartsMap.leafArea.id)}>
              {chartsMap.leafArea.title}
            </Checkbox>
          )}
          {metricsMap.includes(chartsMap.leafNdvi.id) && (
            <Checkbox value={chartsMap.leafNdvi.id} disabled={isDisabled(chartsMap.leafNdvi.id)}>
              {chartsMap.leafNdvi.title}
            </Checkbox>
          )}
          {metricsMap.includes(chartsMap.soilNdvi.id) && (
            <Checkbox value={chartsMap.soilNdvi.id} disabled={isDisabled(chartsMap.soilNdvi.id)}>
              {chartsMap.soilNdvi.title}
            </Checkbox>
          )}
          <Checkbox value={chartsMap.ndvi.id} disabled={isDisabled(chartsMap.ndvi.id)}>
            {chartsMap.ndvi.title}
          </Checkbox>
          {showBbchData && (
            <Checkbox value={chartsMap.bbch.id} disabled={isDisabled(chartsMap.bbch.id)}>
              {chartsMap.bbch.title}
            </Checkbox>
          )}
        </div>

        {/*Soil*/}
        {showSoilData && countOfDepths && countOfDepths.length > 0 && (
          <>
            {/*Humidity*/}
            {metricsMap.includes('soilHumidity_10') && (
              <div className={styles.chartsCustomFilterItem}>
                <div className={styles.chartsCustomFilterItemTitle}>
                  <CroplerIcon name="shovel" />
                  {chartsMap.soilHumidity.title}
                </div>
                {countOfDepths.map((item) => (
                  <Checkbox
                    key={`soilHumidity_${item.value}`}
                    value={`soilHumidity_${item.value}`}
                    disabled={isDisabled(`soilHumidity_${item.value}`)}
                  >
                    {item.value} cm
                  </Checkbox>
                ))}
              </div>
            )}

            {/*Temperature*/}
            {metricsMap.includes('soilTemperature_10') && (
              <div className={styles.chartsCustomFilterItem}>
                <div className={styles.chartsCustomFilterItemTitle}>
                  <CroplerIcon name="shovel" />
                  {chartsMap.soilTemperature.title}
                </div>
                {countOfDepths.map((item) => (
                  <Checkbox
                    key={item.value + 'soilTemperature'}
                    value={`soilTemperature_${item.value}`}
                    disabled={isDisabled(`soilTemperature_${item.value}`)}
                  >
                    {item.value} cm
                  </Checkbox>
                ))}
              </div>
            )}

            {/*Salinity*/}
            {metricsMap.includes('salinity_10') && (
              <div className={styles.chartsCustomFilterItem}>
                <div className={styles.chartsCustomFilterItemTitle}>
                  <CroplerIcon name="shovel" />
                  {chartsMap.salinity.title}
                </div>
                {countOfDepths.map((item) => (
                  <Checkbox
                    key={item.value + 'salinity'}
                    value={`salinity_${item.value}`}
                    disabled={isDisabled(`salinity_${item.value}`)}
                  >
                    {item.value} cm
                  </Checkbox>
                ))}
              </div>
            )}
          </>
        )}
      </Checkbox.Group>

      <div className={styles.chartsCustomFilterNav}>
        {showMessage && <div className={styles.chartsCustomFilterMessage}>{t('charts.custom.message')}</div>}
        {/*{selected.length === 2 && <div>You’ve reached the maximum of items for comparison</div>}*/}
        <Button type="primary" size="large" disabled={selected.length !== 2 || showMessage} onClick={onSave}>
          {t('charts.custom.create')}
        </Button>
      </div>
    </div>
  );
};

export default ChartsCustomFilter;
